import React from 'react'

export default function Footer() {
  return (
    <footer>
        <a href="https://sakukovanen.fi" target="_blank" rel="noreferrer">Website by Saku Kovanen</a>
    </footer>
  )
}
